import { CarRefItemStatus } from "../constants/car-basic-data";
import { CarEngine } from "./car-engine.model";
import { CarFeature } from "./car-feature.model";


export class CarMake {
    id: number = 0;
    
    code = '';
    name = '';

    manufacturerId = 0;
    manufacturerCode = '';
    manufacturerName = '';

    details = '';
    startYear = 1900;
    endYear = 2099;
    status: CarRefItemStatus = CarRefItemStatus.REVIEW;

    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string, manufacturerId: number)  {
        this.code = code!;
        this.name = name!;
        this.manufacturerId = manufacturerId!;
    }
  }
  